import React, { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import { useApp } from "../AppProvider"
import { useApi } from "../hooks/useApi"

export const AuthCheck: React.FC = () => {
  const { user, setUser, token, setMembership, isAnonymous, anonToken, addToast } = useApp()
  const { me } = useApi()
  const navigate = useNavigate()
  const location = useLocation()

  const fetchUser = async () => {
    const response = await me()
    let membership = response?.membership
    let user = response?.user

    setUser(user)
    setMembership(membership)
    if (location.pathname === "/login" || location.pathname === "/") {
      if (user && membership) {
        navigate(`/organizations/${membership.organization}`)
      } else {
        addToast("Error", "There was an error accessing your account", "error")
      }
    }
    return user
  }

  useEffect(() => {
    // Skip auth check if we're on a share route or in anonymous mode
    const isShareRoute = location.pathname.startsWith("/share/")
    const hasAnonAccess = isAnonymous || anonToken

    if (isShareRoute || hasAnonAccess) {
      return // Skip authentication checks for anonymous access
    }

    if (!user && token === "" && !["/", "/home"].includes(location.pathname)) {
      navigate("/login")
    } else if (!user && token) {
      fetchUser()
    }
  }, [user, token, navigate, location.pathname, isAnonymous, anonToken])

  return null
}
